import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const getSchema = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    name: yup.string().required(t("validation.required")),
    infoSystem: yup.object().shape({
      label: yup.string().required(t("validation.required")),
      value: yup.string().required(t("validation.required")),
    }),
    file: yup.string().required(t("validation.required")).nullable(),
  });
};
